<template>
    <div id="sidebar" :class="[status_bar == true ? 'menuFull' : '']" class="col col-md-3 col-lg-3 col-xl-2"><!--collapse navbar-collapse-->
        <ul class="nav flex-column">
            <!--<router-link class="nav-item" tag="li" :to="{name: 'adm.dashboard'}">-->
                <!--<i class="fas fa-tachometer-alt"></i><span class="nameLink">Dashboard</span>-->
            <!--</router-link>-->
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.users'}">
                <i class="fas fa-users"></i><span class="nameLink">Usuários</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.slides'}">
                <i class="fas fa-image"></i><span class="nameLink">Slides</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.videos'}">
                <i class="fas fa-play"></i><span class="nameLink">Videos</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.service'}">
                <i class="fas fa-file-image"></i><span class="nameLink">Serviços</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.homeCall'}">
                <i class="fas fa-file-image"></i><span class="nameLink">Chamadas da home</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.appPhotoGallery'}">
                <i class="fas fa-images"></i><span class="nameLink">Galeria de fotos</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.menu'}">
                <i class="fa fa-ellipsis-h"></i><span class="nameLink">Menu</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.curriculum'}">
                <i class="fas fa-file"></i><span class="nameLink">Curriculos</span>
            </router-link>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.budget'}">
                <i class="fas fa-file-archive"></i><span class="nameLink">Orçamentos</span>
            </router-link>
            <hr>
            <router-link class="nav-item d-flex" tag="li" :to="{name: 'adm.config'}">
                <i class="fas fa-cogs"></i><span class="nameLink">Configurações</span>
            </router-link>
        </ul>
    </div>
</template>

<script>
    import {mapGetters,} from 'vuex';
    export default {
        name: "Seidebar",
        computed: {
            ...mapGetters({
                routes: 'getRoutes',
                status_bar: 'statusBar'
            })
        }
    }
</script>

<style lang="scss">
    @import "../../assets/sass/variables";

    #sidebar {
        min-height: calc(100vh - 72px);
        padding: 0;
        flex: 0 0 auto;
        background-color: $secondary;
        //flex: 0 0 16.66666667%;
        //width: 50px;
        /*@media (max-width: 992px)and(min-width: 519px) {
            flex: 0 0 50px;
        }*/

        ul {
            hr{
                margin:0;
                border-top: 1px solid rgba(0, 0, 0, 0.3);
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
            li {
                cursor: pointer;
                padding: 10px 10px 10px 15px;
                position: relative;
                i {
                    color: #ffffff;
                    font-size: 20px;
                    line-height: 1.2;
                    width: 25px;
                    text-align: center;
                    display: inline-table;
                }
                .nameLink {
                    text-decoration: none;
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: bold;
                    margin-left: 15px;
                }
                &.active{
                    background-color: lighten($secondary,20);
                    border-left: 5px solid $primary-site;
                    padding-left: 10px;
                }
                &:hover{
                    background-color: lighten($secondary,20);
                }
                /*@media (max-width: 992px)and(min-width: 519px) {
                    .nameLink{
                        display: none;
                    }
                    &:hover{
                        .nameLink{
                            display: block;
                            position: absolute;
                            top: 0;
                            left: 15px;
                            background: $primary-site;
                            z-index: 9999;
                            white-space: nowrap;
                            padding: 10px;
                        }
                    }
                }*/
            }
            .sub-menu {
                list-style: none;
                color: #FFFFFF;
                .active {
                    background-color: lighten($secondary,20);
                }

                li {
                    padding: 0.3rem 0.3rem 0.3rem 0.5rem;
                    i {
                        display: block;
                        font-size: 18px;
                        float: left;
                        margin: 0.1rem 0.5rem 0 0;
                    }
                    a {
                        color: #FFFFFF;
                        text-decoration: none;
                    }
                }
            }
        }
        /*&.shortened {
            flex: 0 0 auto !important;
            width: 50px !important;;
            li {
                .nameLink {
                    display: none !important;;
                }
                &:hover {
                    .nameLink {
                        display: block !important;;
                        position: absolute !important;;
                        top: 0 !important;;
                        left: 30px !important;;
                        background: $primary-site !important;;
                        z-index: 9999 !important;;
                        white-space: nowrap !important;;
                        padding: 10px !important;;
                    }
                }
            }

        }*/
    }
</style>
